module.exports = __webpack_public_path__ + "static/media/Clinical_Evidence.1736f048.mp4";